import { gql } from 'apollo-boost';

export default gql`
  {
    getUpcItems {
      keyIndex
      shortDescription
      longDescription
      allDescriptions
      nacsCode
      nacsCodeNote
      createdDate
      modifiedDate
    }
  }
`;
